import { Div, DivProps, P, Span } from '@kizi/core-components';
import React from 'react';

export interface MainCoveragePriceProps extends DivProps {
  label?: string;
  value: number | string;
  title?: string;
}

export const MainCoveragePrice: React.VFC<MainCoveragePriceProps> = ({
  label,
  value,
  title,
  ...rest
}) => {
  const [first, second] = React.useMemo(() => {
    const number = Number(value);
    if (Number.isNaN(number)) return [null, null];
    const _value = number.toFixed(2);
    const [f, s] = _value.split('.');
    return [`€${f}`, `,${s}`];
  }, [value]);
  if (first === null && second === null) {
    return null;
  }
  return (
    <Div
      display="flex"
      flexDirection="column"
      gridGap={1}
      textAlign="right"
      data-testid="MainCoveragePrice"
      {...rest}
    >
      {title && (
        <P
          variant="footnoteRegularToCaptionSmall"
          data-testid="MainCoveragePrice.title"
        >
          {title}
        </P>
      )}
      <Div data-testid="MainCoveragePrice.value">
        <Span
          variant="paragraphs.coverageCardWholePrice"
          data-testid="MainCoveragePrice.value.0"
        >
          {first}
        </Span>
        <Span
          variant="paragraphs.coverageCardFractionPrice"
          data-testid="MainCoveragePrice.value.1"
        >
          {second}
        </Span>
      </Div>
      {label && (
        <P
          variant="footnoteRegularToCaptionSmall"
          data-testid="MainCoveragePrice.label"
        >
          {label}
        </P>
      )}
    </Div>
  );
};
